/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const VesselType = {
    Container: 'Container',
    BargeCarrier: 'BargeCarrier',
    ContainerRoRo: 'ContainerRoRo',
    Feeder: 'Feeder',
    GeneralCargo: 'GeneralCargo',
    LoLo: 'LoLo',
    RoRo: 'RoRo',
    SemiContainer: 'SemiContainer',
} as const;

export type VesselType = typeof VesselType[keyof typeof VesselType];



